import * as React from 'react';
export const IcWarranty = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.71 11.29a1.004 1.004 0 10-1.42 1.42l3 3a.999.999 0 001.42 0l10-10a1.004 1.004 0 00-1.42-1.42L11 13.59l-2.29-2.3zM20.83 10a1 1 0 00-.83 1.12c.015.293.015.587 0 .88a8 8 0 11-8-8 7.82 7.82 0 013.55.84 1.002 1.002 0 00.9-1.79A9.84 9.84 0 0012 2a10 10 0 1010 10 8.323 8.323 0 00-.07-1.12 1 1 0 00-1.1-.88z'
      fill='currentColor'
    />
  </svg>
);
